// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../node_modules/less-loader/dist/cjs.js!../../../shared/CampaignPanel/panel.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VQBKBq0UPtZtk7KoAI3_ {
}
.izj0GEWZsrfTqUg0BVQs {
}
._aO8J90BtGuN_tu3_HNF {
}
.zKFSZI6DCuGbFLEqrwO3 {
}
.dXtgns2apL7PFXU2uQWT {
}
/* Overrides the rules in the shared css file
  ../../../shared/CampaignPanel/panel.module.css
*/
@media (orientation: landscape) {
  .VQBKBq0UPtZtk7KoAI3_ {
    background-size: cover;
  }
  .VQBKBq0UPtZtk7KoAI3_[data-has-many='false'] {
    background-size: contain;
  }
}
.SnxHOON6QiXAalIO9wMl {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 100px;
  width: 263px;
  margin: 15px auto auto;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .SnxHOON6QiXAalIO9wMl {
    height: 83px;
    width: 210px;
    margin-top: -5px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .SnxHOON6QiXAalIO9wMl {
    height: 70px;
    width: 175px;
    margin-top: 0;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .SnxHOON6QiXAalIO9wMl {
    height: 70px;
    width: 175px;
    margin-top: 0;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/TournamentPanel/TournamentPanel.module.css"],"names":[],"mappings":"AAAA;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;;CAEC;AACD;EACE;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;AAAA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;AACF;AAAA;AANA;AAAA;AAAA;AAAA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;AACF;AAAA;AAAA;AAAA","sourcesContent":[".panelContainer {\n  composes: panelContainer from '../../../shared/CampaignPanel/panel.module.css';\n}\n.centerInfoWrapper {\n  composes: centerInfoWrapper from '../../../shared/CampaignPanel/panel.module.css';\n}\n.campaignInfoTitle {\n  composes: campaignInfoTitle from '../../../shared/CampaignPanel/panel.module.css';\n}\n.periodWrapper {\n  composes: periodWrapper from '../../../shared/CampaignPanel/panel.module.css';\n}\n.separator {\n  composes: separator from '../../../shared/CampaignPanel/panel.module.css';\n}\n/* Overrides the rules in the shared css file\n  ../../../shared/CampaignPanel/panel.module.css\n*/\n@media (orientation: landscape) {\n  .panelContainer {\n    background-size: cover;\n  }\n  .panelContainer[data-has-many='false'] {\n    background-size: contain;\n  }\n}\n.tournamentsOverlayLogo {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 100px;\n  width: 263px;\n  margin: 15px auto auto;\n}\n@media (--campaign-mobile) {\n  .tournamentsOverlayLogo {\n    height: 83px;\n    width: 210px;\n    margin-top: -5px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .tournamentsOverlayLogo {\n    height: 70px;\n    width: 175px;\n    margin-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelContainer": `VQBKBq0UPtZtk7KoAI3_ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panelContainer"]}`,
	"centerInfoWrapper": `izj0GEWZsrfTqUg0BVQs ${___CSS_LOADER_ICSS_IMPORT_0___.locals["centerInfoWrapper"]}`,
	"campaignInfoTitle": `_aO8J90BtGuN_tu3_HNF ${___CSS_LOADER_ICSS_IMPORT_0___.locals["campaignInfoTitle"]}`,
	"periodWrapper": `zKFSZI6DCuGbFLEqrwO3 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["periodWrapper"]}`,
	"separator": `dXtgns2apL7PFXU2uQWT ${___CSS_LOADER_ICSS_IMPORT_0___.locals["separator"]}`,
	"tournamentsOverlayLogo": `SnxHOON6QiXAalIO9wMl`
};
export default ___CSS_LOADER_EXPORT___;
